module.exports = __webpack_public_path__ + "static/media/23.9e78e107.png";